import PackagesAttributesTemplate from './PackagesAttributesTemplate'

export * from './PackagesAttributesTemplate'

export default PackagesAttributesTemplate